export enum EstadoProcesoCierre {
  MEMBRESIA_DEFINICION_METAS = "MEMBRESIA_DEFINICION_METAS",
  MEMBRESIA_CONFIGURACION_PLANTILLA = "MEMBRESIA_CONFIGURACION_PLANTILLA",
  MEMBRESIA_CONFIRMACION_PLANTILLA = "MEMBRESIA_CONFIRMACION_PLANTILLA",
  MEMBRESIA_CALCULO_ALCANCES = "MEMBRESIA_CALCULO_ALCANCES",
  MEMBRESIA_CONFIRMACION_ALCANCES = "MEMBRESIA_CONFIRMACION_ALCANCES",
  MEMBRESIA_PRECALCULO_MENSUAL = "MEMBRESIA_PRECALCULO_MENSUAL",
  MEMBRESIA_CALCULO_MENSUAL = "MEMBRESIA_CALCULO_MENSUAL",
  MEMBRESIA_PRECALCULO_POSTQUINCENAL = "MEMBRESIA_PRECALCULO_POSTQUINCENAL",
  MEMBRESIA_CALCULO_POSTQUINCENAL = "MEMBRESIA_CALCULO_POSTQUINCENAL",
  ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS = "ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS",
  ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES = "ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES",
  ANUALIDAD_CONTACT_CENTER_PRECALCULO = "ANUALIDAD_CONTACT_CENTER_PRECALCULO",
  ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL = "ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL",
  ANUALIDAD_CLUB_DEFINICION_METAS = "ANUALIDAD_CLUB_DEFINICION_METAS",
  ANUALIDAD_CLUB_CALCULO_ALCANCES = "ANUALIDAD_CLUB_CALCULO_ALCANCES",
  ANUALIDAD_CLUB_PRECALCULO = "ANUALIDAD_CLUB_PRECALCULO",
  ANUALIDAD_CLUB_CALCULO_MENSUAL = "ANUALIDAD_CLUB_CALCULO_MENSUAL",
  ANUALIDAD_CLUB_CALCULO_SEMESTRAL = "ANUALIDAD_CLUB_CALCULO_SEMESTRAL",
  CITA_CONTACT_CENTER_CALCULO_MENSUAL = "CITA_CONTACT_CENTER_CALCULO_MENSUAL",
  PROCESO_COMPLETADO = "PROCESO_COMPLETADO"
}

export const EstadoProcesoLabels: Record<EstadoProcesoCierre, string> = {
  [EstadoProcesoCierre.MEMBRESIA_DEFINICION_METAS]: "Metas definidas",
  [EstadoProcesoCierre.MEMBRESIA_CONFIGURACION_PLANTILLA]:
    "Plantilla configurada",
  [EstadoProcesoCierre.MEMBRESIA_CONFIRMACION_PLANTILLA]:
    "Plantilla confirmada",
  [EstadoProcesoCierre.MEMBRESIA_CALCULO_ALCANCES]:
    "Cálculo de porcentajes de alcances",
  [EstadoProcesoCierre.MEMBRESIA_CONFIRMACION_ALCANCES]:
    "Porcentajes de alcances confirmados",
  [EstadoProcesoCierre.MEMBRESIA_PRECALCULO_MENSUAL]: "Precálculo mensual",
  [EstadoProcesoCierre.MEMBRESIA_CALCULO_MENSUAL]:
    "Cálculo mensual de comisiones",
  [EstadoProcesoCierre.MEMBRESIA_PRECALCULO_POSTQUINCENAL]:
    "Precálculo postquincenal",
  [EstadoProcesoCierre.MEMBRESIA_CALCULO_POSTQUINCENAL]:
    "Cálculo postquincenal de comisiones",
  [EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS]:
    "Anualidad Contact Center - Definición de metas y plantilla",
  [EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES]:
    "Anualidad Contact Center - Cálculo de porcentajes de alcances",
  [EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO]:
    "Anualidad Contact Center - Precálculo mensual",
  [EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL]:
    "Anualidad Contact Center - Cálculo mensual de comisiones",
  [EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS]:
    "Anualidad Clubes - Definición de metas semestrales",
  [EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES]:
    "Anualidad Clubes - Cálculo de porcentajes de alcances",
  [EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO]:
    "Anualidad Clubes - Precálculo mensual",
  [EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL]:
    "Anualidad Clubes - Cálculo mensual de comisiones",
  [EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL]:
    "Anualidad Clubes - Cálculo semestral de comisiones",
  [EstadoProcesoCierre.CITA_CONTACT_CENTER_CALCULO_MENSUAL]:
    "Cita Contact Center - Cálculo mensual de comisiones",
  [EstadoProcesoCierre.PROCESO_COMPLETADO]: "Proceso completado"
};

const numericValue = (estado: EstadoProcesoCierre) => {
  switch (estado) {
    // Membresía
    case EstadoProcesoCierre.MEMBRESIA_DEFINICION_METAS:
      return 1;
    case EstadoProcesoCierre.MEMBRESIA_CONFIGURACION_PLANTILLA:
      return 2;
    case EstadoProcesoCierre.MEMBRESIA_CONFIRMACION_PLANTILLA:
      return 3;
    case EstadoProcesoCierre.MEMBRESIA_CALCULO_ALCANCES:
      return 4;
    case EstadoProcesoCierre.MEMBRESIA_CONFIRMACION_ALCANCES:
      return 5;
    case EstadoProcesoCierre.MEMBRESIA_PRECALCULO_MENSUAL:
      return 6;
    case EstadoProcesoCierre.MEMBRESIA_CALCULO_MENSUAL:
      return 7;
    case EstadoProcesoCierre.MEMBRESIA_PRECALCULO_POSTQUINCENAL:
      return 8;
    case EstadoProcesoCierre.MEMBRESIA_CALCULO_POSTQUINCENAL:
      return 9;

    // Anualidad Contact Center
    case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_DEFINICION_METAS:
      return 1;
    case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_ALCANCES:
      return 2;
    case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_PRECALCULO:
      return 3;
    case EstadoProcesoCierre.ANUALIDAD_CONTACT_CENTER_CALCULO_MENSUAL:
      return 4;

    // Anualidad Club
    case EstadoProcesoCierre.ANUALIDAD_CLUB_DEFINICION_METAS:
      return 1;
    case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_ALCANCES:
      return 2;
    case EstadoProcesoCierre.ANUALIDAD_CLUB_PRECALCULO:
      return 3;
    case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_MENSUAL:
      return 4;
    case EstadoProcesoCierre.ANUALIDAD_CLUB_CALCULO_SEMESTRAL:
      return 5;

    // Cita Contact Center
    case EstadoProcesoCierre.CITA_CONTACT_CENTER_CALCULO_MENSUAL:
      return 1;

    // Proceso completado (valor más alto para todos los procesos)
    case EstadoProcesoCierre.PROCESO_COMPLETADO:
      return 100;

    default:
      return 0;
  }
};

export function mayorQue(
  estado: EstadoProcesoCierre,
  estadoComp: EstadoProcesoCierre
): boolean {
  return numericValue(estado) > numericValue(estadoComp);
}

export function mayorIgualQue(
  estado: EstadoProcesoCierre,
  estadoComp: EstadoProcesoCierre
): boolean {
  return numericValue(estado) >= numericValue(estadoComp);
}

export function menorQue(
  estado: EstadoProcesoCierre,
  estadoComp: EstadoProcesoCierre
): boolean {
  return numericValue(estado) < numericValue(estadoComp);
}
